"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfiguration = void 0;
var react_1 = __importDefault(require("react"));
var defaultContext = {
    isDark: false,
    zIndex: 1,
};
var ConfigurationContext = react_1.default.createContext(defaultContext);
function useConfiguration() {
    var context = react_1.default.useContext(ConfigurationContext);
    if (context === undefined) {
        console.warn('Component intended to be used in <PageHeader>');
        return defaultContext;
    }
    return context;
}
exports.useConfiguration = useConfiguration;
exports.default = ConfigurationContext;
//# sourceMappingURL=context.js.map